<script setup>
    import { ref, watch } from 'vue';
    import axios from 'axios';
    import * as bootstrap from 'bootstrap';
    import '@vuepic/vue-datepicker/dist/main.css'

    const props = defineProps(['copyUrl', 'participantData']);
    const emit = defineEmits(['reloadPage']);
    const teilnehmer = ref({
        Rechnungsempfaenger: props.participantData.customerNr,
        Teilnehmer: props.participantData.participantNr,
        Vorname: props.participantData.name,
        Name: props.participantData.givenname,
        Kartennummer: '',
    });

    const submitResult = ref(null);
    const submitError = ref(null);
    const isLoading = ref(null);
    const showInfo = ref(null);

    watch(props.participantData, (data, prevData) => {
            teilnehmer.value.Rechnungsempfaenger = data.customerNr;
            teilnehmer.value.Teilnehmer = data.participantNr;
            teilnehmer.value.Vorname = data.name;
            teilnehmer.value.Name = data.givenname;
        }
    )

    // Loads a bootstrap modal & saving the new teilnehmer.
    async function saveTeilnehmer() {
        try {
            isLoading.value = true;
            showInfo.value = true;
            const response = await axios.post(props.copyUrl, teilnehmer.value);
            submitResult.value = response;

            // Close the first modal after a one-second delay
            setTimeout(() => {
                const currentModal = document.querySelector('#modalTeilnehmerCopy');
                const modal = bootstrap.Modal.getInstance(currentModal);
                modal.hide();
                // Reload the page after a two-second delay
                setTimeout(() => {
                    teilnehmer.value.Vorname = props.participantData.name;
                    teilnehmer.value.Name = props.participantData.givenname;
                    teilnehmer.value.Kartennummer = '';
                    isLoading.value = null;
                    showInfo.value = null;
                    emit('reloadPage');
                }, 1000);
            }, 1000);
        } catch (error) {
            isLoading.value = null;
            showInfo.value = null;
            submitError.value = error;
            setTimeout(() => {
                submitError.value = null;
            }, 3000);
        }
    }

    // Loads a bootstrap modal & saving the new teilnehmer.
    async function saveTeilnehmerContinue() {
        try {
            isLoading.value = true;
            showInfo.value = true;
            const response = await axios.post(props.copyUrl, teilnehmer.value);
            submitResult.value = response;

            // Close the first modal after a one-second delay
            setTimeout(() => {
                teilnehmer.value.Vorname = props.participantData.name;
                teilnehmer.value.Name = props.participantData.givenname;
                teilnehmer.value.Kartennummer = '';
                isLoading.value = null;
                showInfo.value = null;
            }, 1000);
        } catch (error) {
            isLoading.value = null;
            showInfo.value = null;
            submitError.value = error;
            setTimeout(() => {
                submitError.value = null;
            }, 3000);
        }
    }





</script>

<template>
    <div>
    <form @submit.prevent="submit">
        <div class="row">
            <div class="col-sm-4 mb-2">
                <label for="kartennummer">Kartennummer (*)</label>
                <input id="kartennummer"
                    type="text"
                    v-model="teilnehmer.Kartennummer"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Kartennummer !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Kartennummer !== 'undefined')" v-html="submitError.response.data.Kartennummer[0]"></div>
            </div>

            <div class="col-sm-4 mb-2">
                <label for="vorname">Vorname (*)</label>
                <input id="vorname"
                    type="text"
                    v-model="teilnehmer.Vorname"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Vorname !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Vorname !== 'undefined')" v-html="submitError.response.data.Vorname[0]"></div>
            </div>

            <div class="col-sm-4">
                <label for="name">Name (*)</label>
                <input id="name"
                    type="text"
                    v-model="teilnehmer.Name"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Name !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Name !== 'undefined')" v-html="submitError.response.data.Name[0]"></div>
            </div>





        </div>
        <p>Felder mit einem * sind Pflichtfelder.</p>
        <button type="submit" class="btn btn-primary" @click.prevent="saveTeilnehmer()">Teilnehmer hinzufügen
            <i :class="[isLoading ? 'fa-solid fa-spinner fa-spin' : '']" :disabled="isLoading"></i>
        </button>
        <button type="submit" class="btn btn-primary" @click.prevent="saveTeilnehmerContinue()">Teilnehmer hinzufügen und weitermachen
            <i :class="[isLoading ? 'fa-solid fa-spinner fa-spin' : '']" :disabled="isLoading"></i>
        </button>
        <p v-if="showInfo" class="text-warning">If saving takes too long, check S&B api connection. Await 60s.</p>
    </form>
    <div class="alert alert-success" role="alert" v-if="submitResult !== null && (submitResult.status === 201 || submitResult.status === 200)">
        <span>Teilnehmer erfolgreich hinzugefügt.</span>
    </div>
    <div class="alert alert-error" role="alert" v-if="submitError != null">
        <span>{{submitError.response.data.message}}</span>
    </div>
</div>
</template>
